<script setup>
import { defineOptions, onMounted } from 'vue';
import ProductItem from '@/components/front/product/ProductItem.vue';

defineOptions({
  name: 'ProductItemApp'
});

onMounted(() => {
  u.trigger('product.item.loaded');
});

const data = u.data('product.item.props');

</script>

<template>
  <div>
    <ProductItem :data="data"></ProductItem>
  </div>
</template>


<style scoped>

</style>
